import { addDays, startOfDay } from 'date-fns';
import type { Interval } from '../types/ScheduleTask';

// Next local midnight strictly after `now`. The schedule range is anchored at
// `startOfDay(now)`, so the local-day rollover is itself a boundary at which
// availability and the anchored range must be re-derived. addDays keeps this
// correct across DST transitions (a fixed +24h would not).
const nextLocalMidnight = (now: Date): number =>
  addDays(startOfDay(now), 1).getTime();

// Smallest boundary strictly greater than now across all window beginnings and
// ends plus the next local midnight, or null.
export const computeNextBoundary = (
  windows: Interval[],
  now: Date
): Date | null => {
  const nowMs = now.getTime();
  let next = Infinity;
  const consider = (ms: number) => {
    if (ms > nowMs && ms < next) next = ms;
  };
  for (const { beginning, end } of windows) {
    consider(beginning.getTime());
    consider(end.getTime());
  }
  consider(nextLocalMidnight(now));
  return next === Infinity ? null : new Date(next);
};
